import { TranslationMap } from '@trimble-gcs/i18n-types';

export function logoutTranslations() {
  return {
    logout: {
      signingOut: {
        label: {
          text: $localize`:@@auth.logout.signingOut.label:Signing out...`,
          desc: 'Label displayed with a progress spinner while the user is being signed out.',
        },
      },
      signedOut: {
        label: {
          text: $localize`:@@auth.logout.signedOut.label:You have signed out.`,
          desc: 'Label displayed after user sign-out is complete.',
        },
      },
      signIn: {
        button: {
          text: $localize`:@@auth.logout.signIn.button:Sign in`,
          desc:
            'Text on a button below the "You have signed out" message. ' +
            'Its purpose is to let the user sign in again.',
        },
      },
    },
  } satisfies TranslationMap;
}
